/**
 * Where the app starts.
 *
 * This file does almost nothing on purpose: it finds the empty <div> in
 * index.html and tells React to draw the app inside it. The app itself is
 * App.tsx.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing its <div id=\"root\">.");

createRoot(root).render(
  <StrictMode>
    {/* BrowserRouter is what lets the app have separate screens with their
        own addresses, without ever reloading the page. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
